export class MarkerClassification {
  icons = [];
  classificationType: any;
  constructor(private classification: string) {
    if (classification == 'Jobs') {
      this.classificationType = JobIconClassification;
    } else if (classification == 'Contractors') {
      this.classificationType = ContractorsIconClassification;
    } else if (classification == 'Mikrotik') {
      this.classificationType = MikrotikIconClassification;
    }  else {
      this.classificationType = GenericIconClassification;
    }
  }

  getClassification() {
    return this.classification;
  }

  getMarkerIcon(iconName: string): string {
    return this.classificationType[iconName];
  }

  setJobIconClassificationType(jobType: string) {
    if (jobType.toLowerCase().trim() == 'maintenance') {
      this.classificationType = JobMaintenance;
    } else if (jobType.toLowerCase().trim() == 'repairs') {
      this.classificationType = JobRepairs;
    } else if (jobType.toLowerCase().trim() == 'installation') {
      this.classificationType = JobInstallation;
    }
  }
  getJobIcon(jobStatus: string, jobPriority: string): string {
    if (jobStatus == 'Completed' || jobStatus == 'Soft Completed' || jobStatus == 'Contractor Completed') {
      jobStatus = 'Complete';
    }
    if (jobStatus == 'Rejected') {
      return 'assets/images/rejectedJob.svg';
    }

    if (this.classificationType[jobStatus.trim().replace(' ', '')] != null && this.classificationType[jobStatus.trim().replace(' ', '')][jobPriority.toLowerCase().trim().replace(' ', '')] != null) {
      return this.classificationType[jobStatus.trim().replace(' ', '')][jobPriority.toLowerCase().trim().replace(' ', '')];
    }

    return '';
  }

  getContractorIcon() {
    return this.classificationType['Employee'];
  }

  getContractorLedger(): any {
    return { Name: 'Employee Contractor', icon: this.classificationType['Employee'] };
  }

  getMikrotikIcon() {
    return this.classificationType['Normal'];
  }
  getMikrotikLedger(): any {
    return { Name: 'Device', icon: this.classificationType['Normal'] };
  }

  getMarkerLedger(iconName: string): any {
    return { Name: iconName + ' ' + this.classification, icon: this.classificationType[iconName] };
  }

  getGenericIcon() {
    return this.classificationType['Normal'];
  }

  getGenericLedger(): any {
    return { Name: 'Location', icon: this.classificationType['Normal'] };
  }

  getJobsLedger(jobType: string, jobStatus: string, jobPriority: string) {
    if (jobStatus == 'Completed' || jobStatus == 'Soft Completed' || jobStatus == 'Contractor Completed') {
      jobStatus = 'Complete';
    }
    if (jobStatus == 'Rejected') {
      return {
        Name: jobType + ' Job - Status=' + jobStatus + ' Priority = ' + jobPriority,
        icon: 'assets/images/rejectedJob.svg',
      };
    }
    if (jobStatus == 'Cancelled') {
      return;
    }
    return {
      Name: jobType + ' Job - Status=' + jobStatus + ' Priority = ' + jobPriority,
      icon: this.classificationType[jobStatus.trim().replace(' ', '')][jobPriority.toLowerCase().trim().replace(' ', '')],
    };
  }
}

const INSTALLATION_IMAGE_BASE_PATH = '/assets/Installation/';
const MAINTENANCE_IMAGE_BASE_PATH = '/assets/Maintenance/';
const REPAIRS_IMAGE_BASE_PATH = '/assets/Repairs/';

enum JobIconClassification {
  SelectContractor = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Emergancy.svg`,
  }),
  Contractor = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Emergancy.svg`,
  }),
  Complete = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Emergancy.svg`,
  }),
  Pending = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Emergancy.svg`,
  }),
}

enum JobMaintenance {
  SelectContractor = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Emergancy.svg`,
  }),
  Contractor = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Pending, Priority=Emergancy.svg`,
  }),
  Complete = Object({
    normal: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Normal.svg`,
    scheduled: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Scheduled.svg`,
    priority: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Priority.svg`,
    afterhours: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=After Hours.svg`,
    emergency: `${MAINTENANCE_IMAGE_BASE_PATH}State=Complete, Priority=Emergancy.svg`,
  }),
}

enum JobRepairs {
  SelectContractor = Object({
    normal: `${REPAIRS_IMAGE_BASE_PATH}Priority=Normal, State=Pending.svg`,
    scheduled: `${REPAIRS_IMAGE_BASE_PATH}Priority=Scheduled, State=Pending.svg`,
    priority: `${REPAIRS_IMAGE_BASE_PATH}Priority=Priority, State=Pending.svg`,
    afterhours: `${REPAIRS_IMAGE_BASE_PATH}Priority=After Hours, State=Pending.svg`,
    emergency: `${REPAIRS_IMAGE_BASE_PATH}Priority=Emergency, State=Pending.svg`,
  }),
  Contractor = Object({
    normal: `${REPAIRS_IMAGE_BASE_PATH}Priority=Normal, State=In Progress.svg`,
    scheduled: `${REPAIRS_IMAGE_BASE_PATH}Priority=Scheduled, State=In Progress.svg`,
    priority: `${REPAIRS_IMAGE_BASE_PATH}Priority=Priority, State=In Progress.svg`,
    afterhours: `${REPAIRS_IMAGE_BASE_PATH}Priority=After Hours, State=In Progress.svg`,
    emergency: `${REPAIRS_IMAGE_BASE_PATH}Priority=Emergency, State=In Progress.svg`,
  }),
  Complete = Object({
    normal: `${REPAIRS_IMAGE_BASE_PATH}Priority=Normal, State=Complete.svg`,
    scheduled: `${REPAIRS_IMAGE_BASE_PATH}Priority=Scheduled, State=Complete.svg`,
    priority: `${REPAIRS_IMAGE_BASE_PATH}Priority=Priority, State=Complete.svg`,
    afterhours: `${REPAIRS_IMAGE_BASE_PATH}Priority=After Hours, State=Complete.svg`,
    emergency: `${REPAIRS_IMAGE_BASE_PATH}Priority=Emergency, State=Complete.svg`,
  }),
}

enum JobInstallation {
  SelectContractor = Object({
    normal: `${INSTALLATION_IMAGE_BASE_PATH}State=Pending, Priority=Normal.svg`,
    scheduled: `${INSTALLATION_IMAGE_BASE_PATH}State=Pending, Priority=Scheduled.svg`,
    priority: `${INSTALLATION_IMAGE_BASE_PATH}State=Pending, Priority=Priority.svg`,
    afterhours: `${INSTALLATION_IMAGE_BASE_PATH}State=Pending, Priority=After Hours.svg`,
    emergency: `${INSTALLATION_IMAGE_BASE_PATH}State=Pending, Priority=Emergency.svg`,
  }),
  Contractor = Object({
    normal: `${INSTALLATION_IMAGE_BASE_PATH}State=In Progress, Priority=Normal.svg`,
    scheduled: `${INSTALLATION_IMAGE_BASE_PATH}State=In Progress, Priority=Scheduled.svg`,
    priority: `${INSTALLATION_IMAGE_BASE_PATH}State=In Progress, Priority=Priority.svg`,
    afterhours: `${INSTALLATION_IMAGE_BASE_PATH}State=In Progress, Priority=After Hours.svg`,
    emergency: `${INSTALLATION_IMAGE_BASE_PATH}State=In Progress, Priority=Emergency.svg`,
  }),
  Complete = Object({
    normal: `${INSTALLATION_IMAGE_BASE_PATH}State=Complete, Priority=Normal.svg`,
    scheduled: `${INSTALLATION_IMAGE_BASE_PATH}State=Complete, Priority=Scheduled.svg`,
    priority: `${INSTALLATION_IMAGE_BASE_PATH}State=Complete, Priority=Priority.svg`,
    afterhours: `${INSTALLATION_IMAGE_BASE_PATH}State=Complete, Priority=After Hours.svg`,
    emergency: `${INSTALLATION_IMAGE_BASE_PATH}State=Complete, Priority=Emergency.svg`,
  }),
}


enum ContractorsIconClassification {
  Employee = '/assets/images/Contractors/Employee.svg',
  ThirdParty = '/assets/images/Contractors/3rd Party.svg',
  Normal = '/assets/images/Contractors/Employee.svg',
}

enum MikrotikIconClassification {
  Nornal = '/assets/images/VodacomOnlineMarker.png',
}

enum GenericIconClassification {
  Normal = '',
}
